import { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import CommonErrorContent from '../CommonErrorContent/CommonErrorContent';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/reducers';
import { reloadPage } from '../../../utils';

const MaintenanceMode: FunctionComponent = () => {
  const history = useHistory();
  const maintenanceModeEnabled = useSelector((state: RootState) => state.featureFlags.FEATURE_FLAG_MAINTENANCE_MODE_ENABLED);
  const { t } = useTranslation('authentication');

  useEffect(() => {
    if (!maintenanceModeEnabled) {
      history.push('/');
    }
  }, [maintenanceModeEnabled, history]);

  const handleClick = () => reloadPage();

  return (
    <CommonErrorContent
      title={t('MaintenanceMode.title')}
      subtitle={t('MaintenanceMode.subtitle')}
      content={t('MaintenanceMode.content')}
      buttonText={t('MaintenanceMode.retryButton')}
      onButtonClick={handleClick}
    />
  );
};

export default MaintenanceMode;
